// extracted by mini-css-extract-plugin
module.exports = {"calculatorInput":"calculatorInput_calculatorInput__RK5is","calculatorInputH5":"calculatorInput_calculatorInputH5__7Gd6H"};